import api from '@/services/api'
import store from '../index'

export default {
  state: {},

  mutations: {},

  actions: {
    async getReportUsersProgress({ commit }) {
      try {
        const { clientId } = store.getters.user

        const response = await api.get(`/${clientId}/reports/users-progress`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
